import React from 'react'

const BannerSection = ({subTitle = "Nice to meet you", heading = 'About Health Architect', paragraph = "Learn more about the Health Architect and their work."}) => {
    return (
        <div className="flex items-center justify-between gap-[24px] bg-[#1C9943] px-[7.7vw] py-[96px] my-[20px]">
            <div className="flex flex-col gap-[12px]">
                <span className="text-[#FFFFFF] font-[500]">
                    {subTitle}
                </span>
                <span className="text-[48px] font-[600] text-[#FFF]">
                    {heading}
                </span>
            </div>
            <span className="text-[#FFFFFF] max-lg:hidden">
                {paragraph}
            </span>
        </div>
    )
}

export default BannerSection